"use client"

import { useEffect } from "react"
import { useAuth } from "@/lib/auth/context"
import { initRevenueCat } from "@/lib/iap/revenuecat"

import { usePlatform } from "@/hooks/use-platform"

export function CapacitorInitializer() {
  const { user } = useAuth()
  const { isNative } = usePlatform()

  useEffect(() => {
    const initCapacitor = async () => {
      try {
        const win = window as any
        if (!win.Capacitor || !isNative) return

        // Initialize Keyboard plugin
        const { Keyboard } = await import('@capacitor/keyboard')
        
        // Hide accessory bar (the "Done" and chevrons)
        await Keyboard.setAccessoryBarVisible({ isVisible: false })
        
        console.log("[Capacitor] Keyboard accessory bar hidden")

        // Initialize RevenueCat
        await initRevenueCat(user?.id)
      } catch (e) {
        console.warn("[Capacitor] Failed to initialize plugins:", e)
      }
    }

    initCapacitor()
  }, [user?.id])

  return null
}
